export default {
  geoLocateApi: 'https://www.googleapis.com/geolocation/v1/geolocate',
  googleApiKey: 'AIzaSyAQw7iUOQxJQYOp_XoyLJXnevV6JhF299A',
};
